import { render, staticRenderFns } from "./CommandeList.vue?vue&type=template&id=422facdb&scoped=true"
import script from "./CommandeList.vue?vue&type=script&lang=js"
export * from "./CommandeList.vue?vue&type=script&lang=js"
import style0 from "./CommandeList.vue?vue&type=style&index=0&id=422facdb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422facdb",
  null
  
)

export default component.exports